import { type InternalTreeMapNode } from '../types/internal.js';

export const getNodesValueSum = (nodes: InternalTreeMapNode[]) => {
  return nodes.reduce((sum, node) => sum + Math.abs(node.value), 0);
};
